import React from 'react';
import { Users, Linkedin, Mail } from 'lucide-react';

// Team members: update/replace these as the team grows
const teamMembers = [
  {
    id: 'miguel-angelo',
    name: 'Miguel Ângelo',
    role: { pt: 'Team Leader', en: 'Team Leader', es: 'Team Leader', fr: 'Team Leader', de: 'Team Leader', ru: 'Team Leader', zh: 'Team Leader' },
    photo: 'https://customer-assets.emergentagent.com/job_realtyhub-19/artifacts/n3d0nlld_Foto-2.png',
    email: '',
    linkedin: ''
  }
];

const ApexTeam = ({ t, language = 'pt' }) => {
  return (
    <section id="team" className="py-32 bg-gradient-to-b from-black via-zinc-950 to-black relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-20 animate-fade-in">
          <h2
            className="text-5xl md:text-6xl lg:text-7xl font-bold heading-luxury mb-6"
            data-testid="apex-team-title"
          >
            <span className="text-white">Apex </span>
            <span className="text-gold">Team</span>
          </h2>

          <div className="h-1 w-24 gold-gradient mx-auto mb-8" />

          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-light">
            {t.apexTeam.description}
          </p>
        </div>

        {/* Members grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          data-testid="apex-team-members-grid"
        >
          {teamMembers.map((member, idx) => (
            <div
              key={member.id}
              className="group relative rounded-2xl overflow-hidden luxury-shadow bg-zinc-900/60 border border-gold/20 hover:border-gold/60 transition-all duration-500"
              data-testid={`apex-team-member-${member.id}`}
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              {/* Photo */}
              <div className="aspect-[3/4] overflow-hidden bg-zinc-900">
                {member.photo ? (
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-900 to-zinc-800">
                    <Users className="h-20 w-20 text-gold/30" />
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
              </div>

              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-6 space-y-2">
                <h3 className="text-2xl font-bold text-white heading-luxury">
                  {member.name}
                </h3>
                <p className="text-gold text-sm tracking-wider uppercase">
                  {member.role[language] || member.role.pt}
                </p>

                {(member.email || member.linkedin) && (
                  <div className="flex items-center gap-3 pt-3">
                    {member.email && (
                      <a
                        href={`mailto:${member.email}`}
                        className="text-gray-400 hover:text-gold transition-colors"
                        aria-label={`Email ${member.name}`}
                        data-testid={`apex-team-email-${member.id}`}
                      >
                        <Mail className="h-4 w-4" />
                      </a>
                    )}
                    {member.linkedin && (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:text-gold transition-colors"
                        aria-label={`LinkedIn ${member.name}`}
                        data-testid={`apex-team-linkedin-${member.id}`}
                      >
                        <Linkedin className="h-4 w-4" />
                      </a>
                    )}
                  </div>
                )}
              </div>

              {/* Gold border sweep on hover */}
              <div className="absolute inset-0 ring-1 ring-inset ring-transparent group-hover:ring-gold/40 rounded-2xl pointer-events-none transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApexTeam;
